import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";

import { COMMUNICATION_ROUTE_SEGMENTS } from "../../shared/routing/paths/communication";
import {
  CommunicationCertificationPagesPage,
  CommunicationCreateCertificationPage,
  CommunicationCustomerInformationPage,
  CommunicationEditCertificationPage,
  CommunicationPage,
  CommunicationReportsPage,
  CommunicationRoute,
  CommunicationTransparencyPage,
} from "./route-elements";

export const CommunicationRoutes = {
  path: COMMUNICATION_ROUTE_SEGMENTS.root,
  element: <CommunicationRoute />,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationPage />
        </Suspense>
      ),
    },
    {
      path: COMMUNICATION_ROUTE_SEGMENTS.reports,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationReportsPage />
        </Suspense>
      ),
    },
    {
      path: COMMUNICATION_ROUTE_SEGMENTS.certificationPages,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationCertificationPagesPage />
        </Suspense>
      ),
    },
    {
      path: `${COMMUNICATION_ROUTE_SEGMENTS.certificationPages}/${COMMUNICATION_ROUTE_SEGMENTS.customerInformation}`,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationCustomerInformationPage />
        </Suspense>
      ),
    },
    {
      path: `${COMMUNICATION_ROUTE_SEGMENTS.certificationPages}/${COMMUNICATION_ROUTE_SEGMENTS.createCertificationPage}`,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationCreateCertificationPage />
        </Suspense>
      ),
    },
    {
      path: `${COMMUNICATION_ROUTE_SEGMENTS.certificationPages}/:certificationId/${COMMUNICATION_ROUTE_SEGMENTS.editCertificationPage}`,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationEditCertificationPage />
        </Suspense>
      ),
    },
    {
      path: COMMUNICATION_ROUTE_SEGMENTS.transparencyPage,
      element: (
        <Suspense fallback={<Spinner />}>
          <CommunicationTransparencyPage />
        </Suspense>
      ),
    },
  ],
};
